import { INSTRUMENT_LINK_TOKEN_QUERY } from './constants'

export function parseInstrumentLinkToken(search: string): string | null {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
  const token = params.get(INSTRUMENT_LINK_TOKEN_QUERY)?.trim()
  return token && token.length >= 10 ? token : null
}
